<footer class="footer mt-4 bottom">
    <div class="footer-copyright text-center py-3" style="color: white;">Copyright <i
            class="far fa-copyright"></i><b> Lobo Game 2021 </b> Todos os direitos reservados.
        <br>
    </div>
</footer>